import { S3Client, ListObjectsCommand, PutObjectCommand, CopyObjectCommand, DeleteObjectCommand, GetObjectCommand } from '@aws-sdk/client-s3';
import { fromCognitoIdentityPool } from '@aws-sdk/credential-provider-cognito-identity';

import config from '../../config';
import { S3_ENCRYPTION_ALGORYTHM } from '../file';

// Set the default credentials.
const credentials = fromCognitoIdentityPool({
    identityPoolId: config.aws.cognito.identityPoolId, // 'IDENTITY_POOL_ID',
    clientConfig: { region: config.aws.cognito.region }, // Configure the underlying CognitoIdentityClient.
});

const s3 = new S3Client({
    region: config.aws.s3.region,
    credentials,
});

export function getObject(filename, encryptionKey = '', params = {}, isStream = true) {
    params.Key = filename;
    if(!params.Bucket) {
        params.Bucket = config.aws.s3.bucket;
    }

    if(encryptionKey) {
        params = {
            ...params,
            ...getEncryptionKeys(encryptionKey),
        };
    }

    // console.log(params);
    const command = new GetObjectCommand(params);
    // if(isStream) {
    //     return s3.send(command); // .then(data => data.Body.transformToString());
    // }
    // return s3.send(command).then(data => data.Body.transformToString());

    return s3.send(command).then(data => {
        // https://docs.aws.amazon.com/sdk-for-javascript/v3/developer-guide/javascript_s3_code_examples.html#:~:text=Get%20an%20object%20from%20a%20bucket
        return isStream ? data.Body.transformToWebStream() : data.Body.transformToByteArray();
    });
}

export function uploadFile(filename, file, encryptionKey = '') {
    console.log(`S3 Upload ::: Start => ${filename}`);

    let params = {
        Key: filename,
        Body: file,
        ContenType: file.type || '',
    };

    if(encryptionKey) {
        params = {
            ...params,
            ...getEncryptionKeys(encryptionKey),
        };
    }

    const command = new PutObjectCommand(params);
    return s3.send(command);
}

export function getFile(filename, encryptionKey = '', params = {}) {
    return getObject(filename, encryptionKey, params);
}

export function streamFile(filename, encryptionKey = '', params = {}) {
    return getObject(filename, encryptionKey, params, true);
}

export function listFiles(path, params = {}) {
    const listRecursive = (onFinish = null, onError = null, files = [], nextMarker = null) => {
        console.log('S3::: listFiles', path, params);

        const command = new ListObjectsCommand({ Prefix: path, Marker: nextMarker, ...params });
        return s3.send(command).then(({ Contents = [], ...result }) => {
            if(Contents.length && result.IsTruncated) {
                // console.log('List larger than 1000 results -> Recursive on listFiles with NextMarker', result.NextContinuationToken);
                if(result.NextMarker && (!params.MaxKeys || params.MaxKeys > (files.length + Contents.length))) {
                    return listRecursive(onFinish, onError, [...files, ...Contents], result.NextMarker);
                }
                console.error('Missing next marker');
            }
            return [
                ...(files || []),
                ...(Contents || []),
            ];
        });
    };

    return listRecursive().then(files => {
        console.log('S3::: ListFiles: count ', files.length);
        return files;
    }).catch(err => {
        console.error(err);
        return [];
    });
}

export function copyFile(sourceFile, destination, isDistinctSourceBucket = false) {
    const params = {
        CopySource: `${isDistinctSourceBucket ? '' : `/${config.aws.s3.bucket}`}/${sourceFile}`,
        Key: destination,
    };
    const command = new CopyObjectCommand(params);
    return s3.send(command);
}

export function deleteFile(path) {
    const command = new DeleteObjectCommand({ Key: path });
    return s3.send(command);
}

export function getEncryptionKeys(encryptionKey) {
    return {
        SSECustomerAlgorithm: S3_ENCRYPTION_ALGORYTHM,
        SSECustomerKey: encryptionKey,
        // SSECustomerKeyMD5: crypto.createHash('md5')
        //     .update(encryptionKey)
        //     .digest('base64'),
    };
}
